<div class="input-group flex-nowrap" *ngIf="!isDisabled">
  <span class="input-group-text"><i class="bi bi-calendar fw-bold"></i>
  </span>
  <input [readOnly]="true" [minDate]="{year: minDate.year, month: minDate.month, day: minDate.day }"
    [maxDate]="{year: maxDate.year, month: maxDate.month, day: maxDate.day }" class="form-control" [firstDayOfWeek]="7"
    placeholder="MMM d, yyyy" name="dp" [value]="getFormattedString(localValue)" (dateSelect)="valueChanged($event)"
    ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" />
  <a (click)="d.toggle()" class="input-group-text bg-light"><i class="bi bi-calendar3 fw-semibold"></i></a>
</div>

<div class="input-group flex-nowrap disabled" *ngIf="isDisabled">
  <span class="input-group-text"><i class="bi bi-calendar fw-bold"></i>
  </span>
  <input [value]="getFormattedString(localValue)" disabled="true" class="form-control form-control-lg input-border"/>
  <span  class="input-group-text bg-light"><i class="bi bi-calendar3 fw-semibold"></i></span>
</div>
